import "./style.scss";
import { FC } from "react";

interface AOPFieldVisibilityToggleProps {
  visible: boolean;
  onChange: (visible: boolean) => void;
  ariaLabel?: string;
}

const AOPFieldVisibilityToggle: FC<AOPFieldVisibilityToggleProps> = ({ visible, onChange, ariaLabel }) => (
  <button
    type="button"
    className={`aop-field-visibility-toggle ${visible ? "is-visible" : "is-hidden"}`}
    aria-label={ariaLabel ?? (visible ? "Hide field in document" : "Show field in document")}
    aria-pressed={visible}
    onClick={() => onChange(!visible)}
  >
    A
  </button>
);

export default AOPFieldVisibilityToggle;
